import { Dispatch, memo, SetStateAction, useState } from 'react'
import { Field, useField } from 'react-final-form'
import { required } from 'forms/validators'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { TOrderCreatePoint } from 'modules/order/types/orderCreateTypes'
import { TScheduleDay } from 'modules/terminal/types'
import { CourierDeliveryInfo } from 'schema'
import { orderOperation } from 'utils/feature'

import { FieldOrderCreatePointOperation } from '../../forms/FieldOrderCreatePointOperation'
import { OrderCreateFormRoute } from '../OrderCreate/OrderCreateFormRoute'

type TProps = {
  departureTerminalId: string
  destinationTerminalId: string
  setDepartureTerminalId: Dispatch<SetStateAction<string>>
  setDepartureTerminalSchedule: Dispatch<SetStateAction<TScheduleDay[] | undefined>>
  setDepartureType: Dispatch<SetStateAction<DeliveryTypeEnum | undefined>>
  setDestinationTerminalId: Dispatch<SetStateAction<string>>
  setDestinationTerminalSchedule: Dispatch<SetStateAction<TScheduleDay[] | undefined>>
  setDestinationType: Dispatch<SetStateAction<DeliveryTypeEnum | undefined>>
}

export const FieldOrderGuestRoutesBlockForm = memo(function FieldOrderGuestRoutesBlockForm({
  departureTerminalId,
  destinationTerminalId,
  setDepartureTerminalId,
  setDestinationTerminalId,
  setDepartureType,
  setDestinationType,
  setDepartureTerminalSchedule,
  setDestinationTerminalSchedule
}: TProps) {
  const {
    input: { value: departureValue },
    meta: departureMeta
  } = useField<TOrderCreatePoint>('departurePoint')
  const {
    input: { value: destinationValue },
    meta: destinationMeta
  } = useField<TOrderCreatePoint>('destinationPoint')
  useField<string>('departurePoint.terminalId', {
    validate: required
  })
  useField<string>('destinationPoint.terminalId', {
    validate: required
  })

  const [searchDepartureAddressValue, setSearchDepartureAddressValue] = useState('')
  const [searchDestinationAddressValue, setSearchDestinationAddressValue] = useState('')
  const { initial: departureInitial } = departureMeta
  const { initial: destinationInitial } = destinationMeta

  const pointError = (pointType: CourierDeliveryInfo.pointType) => {
    const isSubmitFailed =
      pointType === CourierDeliveryInfo.pointType.DEPARTURE
        ? departureMeta.submitFailed && departureMeta.touched
        : destinationMeta.submitFailed && destinationMeta.touched
    let error = ''

    const searchAddressValue =
      pointType === CourierDeliveryInfo.pointType.DEPARTURE
        ? searchDepartureAddressValue
        : searchDestinationAddressValue
    const value = pointType === CourierDeliveryInfo.pointType.DEPARTURE ? departureValue : destinationValue

    if (isSubmitFailed && !searchAddressValue?.length) {
      error = 'Обязательное поле'

      return error
    }
    if (isSubmitFailed && searchAddressValue?.length && value.isCourier === undefined) {
      error = 'Обязательное поле'

      return error
    }
    if (isSubmitFailed && searchAddressValue?.length && (value.isCourier || !value.isCourier) && !value?.terminalId) {
      error = 'Обязательное поле'

      return error
    }
  }

  return (
    <div>
      <Field name="departurePoint" validate={required}>
        {({ input }) => (
          <OrderCreateFormRoute
            isGuest
            error={pointError(CourierDeliveryInfo.pointType.DEPARTURE)}
            initial={departureInitial}
            name="departurePoint"
            pointType={CourierDeliveryInfo.pointType.DEPARTURE}
            searchAddressValue={searchDepartureAddressValue}
            setDepartureTerminalId={setDepartureTerminalId}
            setDepartureTerminalSchedule={setDepartureTerminalSchedule}
            setPointType={setDepartureType}
            setSearchAddressValue={setSearchDepartureAddressValue}
            value={input.value}
            onChange={(val) => {
              input.onChange(val)
            }}
          />
        )}
      </Field>
      {orderOperation && !departureValue.isCourier && (
        <FieldOrderCreatePointOperation name="operation" pointType="departure" terminalId={departureTerminalId} />
      )}
      <Field name="destinationPoint" validate={required}>
        {({ input }) => (
          <OrderCreateFormRoute
            isGuest
            departureTerminalId={departureTerminalId}
            error={pointError(CourierDeliveryInfo.pointType.DESTINATION)}
            initial={destinationInitial}
            name="destinationPoint"
            pointType={CourierDeliveryInfo.pointType.DESTINATION}
            searchAddressValue={searchDestinationAddressValue}
            setDepartureTerminalSchedule={setDestinationTerminalSchedule}
            setDestinationTerminalId={setDestinationTerminalId}
            setPointType={setDestinationType}
            setSearchAddressValue={setSearchDestinationAddressValue}
            value={input.value}
            onChange={(val) => {
              input.onChange(val)
            }}
          />
        )}
      </Field>
      {orderOperation && !destinationValue.isCourier && (
        <FieldOrderCreatePointOperation name="operation" pointType="destination" terminalId={destinationTerminalId} />
      )}
    </div>
  )
})
